import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasInputTarget || !this.hasCountTarget) return

    const current = this.inputTarget.value.length
    const max = parseInt(this.countTarget.dataset.max, 10)

    this.countTarget.textContent = `${current}/${max}`

    if (current > max * 0.9) {
      this.countTarget.classList.remove("text-gray-400")
      this.countTarget.classList.add("text-amber-600")
    } else {
      this.countTarget.classList.remove("text-amber-600")
      this.countTarget.classList.add("text-gray-400")
    }
  }
}
